/******* app.jsform public object ********/
var $cache = {};

/**
	* @private
	* @function
	* @description Updates the cache to include recently added form inputs
	*/
function updateCache(options) {
    $cache = {
        select 	: $('select').not('.jsform-ignore').not('.jsform-custom'),
        radio	: $('input[type="radio"]').not('.jsform-ignore').not('.jsform-custom'),
        checkbox: $('input[type="checkbox"]').not('.jsform-ignore').not('.jsform-custom'),
        number	: $('input[type="number"]').not('.jsform-ignore').not('.jsform-custom')
    };
}
	
	
/**
	* @private
	* @function
	* @description Iniitalizes the forms and splits the options objects to their appropriate plugin
	*/
function initializeForms(options) {
    //options may be passed for each initialization and will fallback to jsform.settings
    var options = options || {},
        iCheckOptions = (options.icheck || app.jsform.settings.icheck),
        selectricOptions = (options.selectric || app.jsform.settings.selectric);

    initializeiCheck(iCheckOptions);
    initializeSelectric(selectricOptions);
}
	
/**
	* @private
	* @function
	* @description Initializes iCheck plugin for checkbox/radio elements
	* @reference https://github.com/fronteed/iCheck/
	*/
function initializeiCheck(options) {
    if ($.fn.iCheck) {
        //capture all current checkbox events
        var events = [];
        var checkboxCount = $cache.checkbox.length;
        for (var checkboxIndex = 0; checkboxIndex < checkboxCount; checkboxIndex++) {
            events[$cache.checkbox[checkboxIndex].name] = $._data($cache.checkbox[checkboxIndex], 'events');
        }

        $cache.radio.iCheck(options);
        $cache.checkbox.iCheck(options);

        //reset all checkbox events from above bc iClick deleted them
        for (var checkboxIndex = 0; checkboxIndex < checkboxCount; checkboxIndex++) {
            var checkbox = $cache.checkbox[checkboxIndex];
            var checkboxEvents = events[checkbox.name];
            for (var eventType in checkboxEvents) {
                var typeCount = checkboxEvents[eventType].length;
                $(checkbox).unbind(eventType);
                if (typeof checkboxEvents[eventType] != 'undefined') { // ND-1385 ... ND-1388
                    for (var eventIndex = 0; eventIndex < typeCount; eventIndex++) {
                        $(checkbox).bind(eventType, checkboxEvents[eventType][eventIndex].handler);
                    }
                }
            }
        }
    } else {
        // console.warn("iCheck plugin not loaded");
    }
}
	
/**
	* @private
	* @function
	* @description Initializes Selectric for select dropdown elements
	* @reference https://github.com/lcdsantos/jQuery-Selectric
	*/
function initializeSelectric(customOptions, $select){
    var options = $.extend(true, {}, app.jsform.settings.selectric, customOptions || {});
    var $selectTargets = $select || $cache.select;

    $selectTargets.closest('.selectricWrapper').find('.selectric').unbind('click');

    $.fn.selectric ? $selectTargets.selectric(options) : console.warn('Selectric plugin not loaded');

    $selectTargets.closest('.selectricWrapper').find('.selectric').click(function(){
        $('.selectricInput').blur();
    });
    // prevents the backspace key from going back a page when a selectric menu is opened
    $(document).keydown(function(e) {
        if ($('.selectricOpen').length > 0) {
            if (e.keyCode === 8) {
                return false;
            }
        }
    });
}
/**
	* @private
	* @function
	* @description Explicitly updates select inputs since they may have changed programatically
	*/
function updateSelects(){
    $cache.select.closest('.selectricWrapper').find('.selectric').unbind('click');

    $.fn.selectric ? $cache.select.selectric('refresh') : console.warn('Selectric plugin not loaded');

    $cache.select.closest('.selectricWrapper').find('.selectric').click(function(){
        $('.selectricInput').blur();
    });
}

var jsform = {
    /**
		* @function
		* @description Intialize forms on page load
		*/
    init : function (options) {
        updateCache();
        initializeForms(options);
        //initializeEvents();
    },
    /**
		* @function
		* @description Intialize forms on modal load or update existing forms
		*/
    refresh : function(){
        app.jsform.init();
        updateSelects();
    },
    /**
		* @function
		* @description Exlplicitly invoke a custom selectric instance
		*/
    selectric : function(customOptions, $select){
        initializeSelectric(customOptions, $select);
    },
    settings : {
        icheck : {
            checkboxClass: 'icheckbox_icon',
            radioClass: 'iradio_icon',
            checkedClass: 'checked',
            disabledClass: 'disabled',
            indeterminateClass: 'indeterminate',
            hoverClass: 'hover',
            focusClass: 'focus',
            activeClass: 'active',
            labelHover: true,
            labelHoverClass: 'hover',
            cursor: true,
            inheritClass: true,
            inheritID: false
            //insert: '',
            //increaseArea: ''
        },
        selectric : {
            arrowButtonMarkup : '<b class="select-dropdown-button"><i class="fa fa-angle-down"></i></b>',
            disableOnMobile : false
        }
    }
};

export default jsform;
